import { Component, inject, input, OnInit } from '@angular/core';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { catchError, of } from 'rxjs';

import { TaskAndAttention } from 'src/app/models/taskAndAttention';
import { MyAttentionService } from 'src/app/services/my-attention.service';
import { MyTasksService } from 'src/app/services/my-tasks.service';

import { TaskViewTableComponent } from './task-view-table/task-view-table.component';

@Component({
  selector: 'app-task-view',
  templateUrl: './task-view.component.html',
  styleUrls: ['./task-view.component.scss'],
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatTableModule,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatProgressSpinnerModule,
    TaskViewTableComponent
  ]
})
export class TaskViewComponent implements OnInit {
  private myTaskService = inject(MyTasksService);
  private myAttentionService = inject(MyAttentionService);

  tasks: { name: string; list: TaskAndAttention[] }[] = [];
  isLoading = true;
  hasLoadingError = false;
  readonly type = input<string>();
  ngOnInit() {
    const request$ =
      this.type() === 'task' ? this.myTaskService.getTasks() : this.myAttentionService.getAttentions();

    request$
      .pipe(
        catchError(() => {
          this.hasLoadingError = true;
          return of([]);
        })
      )
      .subscribe({
        next: (tasksAndAttentions: TaskAndAttention[]) => {
          try {
            this.tasksAndAttentions(tasksAndAttentions);
          } catch {
            this.hasLoadingError = true;
          } finally {
            this.isLoading = false;
          }
        },
        error: () => {
          this.hasLoadingError = true;
          this.isLoading = false;
        }
      });
  }

  tasksAndAttentions(tasksAndAttentions: TaskAndAttention[]) {
    tasksAndAttentions.forEach((taskAndAttention) => {
      this.handleTaskAndAttention(taskAndAttention);
    });
  }

  taskSorter(task: TaskAndAttention, otherTask: TaskAndAttention) {
    const identity = (task.identity ?? '').toLowerCase();
    const otherIdentity = (otherTask.identity ?? '').toLowerCase();
    return identity < otherIdentity ? -1 : identity > otherIdentity ? 1 : 0;
  }

  handleTaskAndAttention(taskAndAttention: TaskAndAttention) {
    let state = taskAndAttention.state;
    const prolostate = taskAndAttention.prolongationStatus;
    const proloRequest = 'Prolongation Requests';
    if (state === '') {
      state = 'DRAFT';
    }
    let entry: { name: string; list: TaskAndAttention[] } | null;
    if (prolostate === 'Asked') {
      entry = this.findEntry(proloRequest);
    } else {
      entry = this.findEntry(state);
    }

    if (entry) {
      entry.list.push(taskAndAttention);
    } else {
      const arr = [taskAndAttention];
      entry = { name: prolostate === 'Asked' ? proloRequest : state, list: arr };
      this.tasks.push(entry);
    }

    this.tasks.forEach((task) => {
      task.list.sort(this.taskSorter);
    });
  }

  findEntry(state: string): { name: string; list: TaskAndAttention[] } | null {
    const filter = this.tasks.filter((task) => {
      return task.name === state;
    });
    return filter.length > 0 ? filter[0] : null;
  }
}
